$("document").ready(function () {
	var accordionHead = $(".table-accordion__item .head")
	accordionHead.on("click", function () {
		$(this).toggleClass("active")
	})
})
